import { v4 as uuidv4 } from 'uuid'

type FormKind = 'contact' | 'ouvidoria'

const storageKeys: Record<FormKind, string> = {
  contact: 'contact-form-idempotency-key',
  ouvidoria: 'ouvidoria-form-idempotency-key',
}

const memoryKeys = new Map<FormKind, string>()

export function getOrCreateFormIdempotencyKey(formKind: FormKind) {
  const memoryKey = memoryKeys.get(formKind)

  try {
    const storageKey = storageKeys[formKind]
    const storedKey = sessionStorage.getItem(storageKey)

    if (storedKey) {
      memoryKeys.set(formKind, storedKey)
      return storedKey
    }

    const idempotencyKey = memoryKey ?? uuidv4()
    sessionStorage.setItem(storageKey, idempotencyKey)
    memoryKeys.set(formKind, idempotencyKey)
    return idempotencyKey
  } catch {
    const idempotencyKey = memoryKey ?? uuidv4()
    memoryKeys.set(formKind, idempotencyKey)
    return idempotencyKey
  }
}

export function clearFormIdempotencyKey(formKind: FormKind) {
  memoryKeys.delete(formKind)

  try {
    sessionStorage.removeItem(storageKeys[formKind])
  } catch {
    // The in-memory key was already cleared.
  }
}
